import { render } from "./CopyFlows.vue?vue&type=template&id=22394054"
import script from "./CopyFlows.vue?vue&type=script&lang=js"
export * from "./CopyFlows.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__